/* tb-hilfe: Suche, Anker (#kuendigen u. a. öffnet die Antwort), Knöpfe mit data-anliegen. Keine Abhängigkeit. */
(function () {
  var root = document.getElementById('tbh');
  if (!root) return;
  function norm(s) { return s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

  function ausHash() {
    var h = '';
    try { h = decodeURIComponent((location.hash || '').slice(1)); } catch (err) { return; }
    if (!h) return;
    var el = document.getElementById(h);
    if (el && el.tagName === 'DETAILS' && el.classList.contains('tbh-f')) {
      el.open = true;
      setTimeout(function () { el.scrollIntoView({ block: 'start' }); }, 60);
    }
  }
  ausHash();
  window.addEventListener('hashchange', ausHash);

  var suche = document.getElementById('tbh-suche'), info = document.getElementById('tbh-suche-info'), leer = document.getElementById('tbh-leer');
  if (suche) {
    suche.addEventListener('input', function () {
      var q = norm(suche.value.trim()), n = 0;
      root.querySelectorAll('.tbh-thema').forEach(function (t) {
        var any = false;
        t.querySelectorAll('details.tbh-f').forEach(function (d) {
          var titel = norm(d.querySelector('summary').textContent);
          var treffer = !q || (titel + ' ' + norm(d.querySelector('.tbh-a').textContent)).indexOf(q) > -1;
          d.style.display = treffer ? '' : 'none';
          if (treffer) { any = true; if (q) n++; }
          d.open = !!(q && treffer && titel.indexOf(q) === -1);
        });
        t.style.display = any ? '' : 'none';
      });
      leer.style.display = q && !n ? 'block' : 'none';
      info.textContent = q ? (n ? n + (n === 1 ? ' passende Frage weiter unten' : ' passende Fragen weiter unten') : 'Keine passende Frage, unten kannst du uns schreiben') : '';
    });
    suche.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      var z = Array.prototype.filter.call(root.querySelectorAll('.tbh-thema'), function (t) { return t.style.display !== 'none'; })[0] || leer;
      z.scrollIntoView({ behavior: 'smooth' });
    });
  }

  // Knöpfe, die ein Anliegen im Formular öffnen (Task 5: window.trendboxKontakt.oeffne)
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-anliegen]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-anliegen');
    var k = window.trendboxKontakt;
    if (k && typeof k.oeffne === 'function' && k.oeffne(id)) return;
    var ziel = document.getElementById('kontakt');
    if (ziel) ziel.scrollIntoView({ behavior: 'smooth' });
  });
})();
